import React from 'react';
import { animated, useSpring } from 'react-spring';
import styled, { css } from 'styled-components';
import type { AppsHashMap, ExtendedAppConfig } from '~/hooks/useApps';
import AppCard, { Props as AppCardProps } from '../../../AppCard';
import { ANIMATION_CONFIG } from '~/styles/constants';

export type Props = {
  apps: AppsHashMap;
};

const AppCards: React.FCC<Props> = ({ apps, ...rest }) => {
  const animation = useSpring(ANIMATION_CONFIG);

  return (
    <AppListContainer style={animation} {...rest}>
      {Object.keys(apps).map(appKey => {
        const app: ExtendedAppConfig | undefined = apps[appKey];

        if (!app) return null;
        const props: AppCardProps = {
          'data-objectid': app.__typename,
          app,
          limited:
            app.appStatus.permission?.__typename ===
            'Permission_AccessDenied_Plan',
        };

        return <AppCard {...props} key={appKey} />;
      })}
    </AppListContainer>
  );
};

const MAX_CARD_WIDTH = 400;

const AppListContainer = styled(animated.section)<{}>(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${MAX_CARD_WIDTH}px, 1fr));

    grid-template-rows: auto 1fr auto;
    grid-row-gap: ${theme.space('l')};
    grid-column-gap: ${theme.space('l')};

    margin-bottom: ${theme.space('xl')};
  `,
);

export default AppCards;
